angular.module('app.filters').filter('min', () => (items) => {
    if (items && items.length) {
        let min = items[0];
        for (let i = 1; i < items.length; ++i) {
            if (min > items[i]) {
                min = items[i];
            }
        }
        return min;
    }

    return 0;
});
